export default "__VITE_ASSET__a6794413__"